import { useAppSelector } from '@/store';

export interface PendingTeamMembership {
  id?: string | null;
  teamId?: string | null;
  teamName?: string | null;
}

export interface UseIsSMBIncompleteResult {
  isSMBIncomplete: boolean;
  pendingTeamMembership: PendingTeamMembership | null;
}

// signup_type is provenance, not current state — set once at createUser
// (api/auth/service/auth_service.go:579) and never mutated. Once an SMB user
// joins a team with billing, hasTeamBilling flips true and isSMBIncomplete
// goes false. Do not mutate signup_type on team join. See ENG-5251 plan.
export function useIsSMBIncomplete(): UseIsSMBIncompleteResult {
  const viewer = useAppSelector((state) => state.viewer);
  const hasTeamBilling = !!viewer.groups?.some((g) => !!g?.billing_account);
  const isSMBIncomplete = !!viewer.id && viewer.signup_type === 'smb' && !hasTeamBilling;
  return {
    isSMBIncomplete,
    pendingTeamMembership: viewer.pendingTeamMembership ?? null,
  };
}
